<template>
  <main class="content">
    <section class="table-container">
      <h2>Current Season</h2>
      <table>
        <thead>
          <tr>
            <th
              colspan="3"
              v-if="currentYearDataToDisplay"
            >{{ currentYearDataToDisplay.yearheading[0] }}</th>
          </tr>
          <tr>
            <th>Pos.</th>
            <th
              v-for="heading in currentYearDataToDisplay.tableheading"
              v-bind:key="heading.id"
            >{{ heading }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(persons, index) in currentYearDataToDisplay.names" v-bind:key="persons.id">
            <td>{{ index + 1 }}.</td>
            <td v-for="entry in persons" v-bind:key="entry.id">{{ entry }}</td>
          </tr>
        </tbody>
      </table>

      <h2 class="inplay">In-play bets</h2>
      <table class="inplay">
        <thead>
          <tr>
            <th
              v-for="heading in inplayDataToDisplay.tableheading"
              v-bind:key="heading.id"
            >{{ heading }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entries in inplayDataToDisplay.details" v-bind:key="entries.id">
            <td v-for="entry in entries" v-bind:key="entry.id">{{ entry }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </main>
</template>

<script>
export default {
  name: "sheetRequest",
  data() {
    return {
      endpoint: "https://sheets.googleapis.com/v4/spreadsheets/",
      spreadsheet: process.env.VUE_APP_SPREADSHEETID,
      apiKey: process.env.VUE_APP_GOOGLE,
      currentYearSelection: "/values/currentapisheet!A1:B10?",
      yearSelection2018: "/values/2018apisheet!A1:B10?",
      inplaySelection: "/values/inplay!A1:C20?",
      currentSheetData: "",
      sheetData2018: "",
      inplayData: "",
      numberOfPeople: 3,
      numberOfYears: 2,
      numberOfHeadings: 2,
      numberOfHeadingsAndPeople: 5,
      currentYearDataToDisplay: "",
      year2018DataToDisplay: "",
      inplayDataToDisplay: ""
    };
  },
  created() {
    this.initCurrentYear();
    this.initInplay();
  },
  mounted() {},
  methods: {
    // Fetch data from spreadsheet, parse JSON and ca
    async fetchData(yearSelect, sheetSelection) {
      const response = await fetch(
        `${this.endpoint}${this.spreadsheet}${yearSelect}key=${this.apiKey}`
      ).then(response => response.json());
      this.saveDataToSelection(response, sheetSelection);
    },

    // Check to see which selection property to save to
    saveDataToSelection(dataToSave, sheetSelection) {
      if (sheetSelection == "currentSheetData") {
        this.currentSheetData = dataToSave;
      } else if (sheetSelection == "sheetData2018") {
        this.sheetData2018 = dataToSave;
      } else {
        this.inplayData = dataToSave;
      }
    },

    submitDataToFirestore(data) {
      const slackObject = {
        currentwinnings: data.toString()
      }
      fetch(
        "https://us-central1-dueawin-30cb4.cloudfunctions.net/testMessage",
        {
          method: "post",
          body: JSON.stringify(data)
        }
      ).then((response) => {
        console.log(response);
        if (response.status === 201) {
          console.log('calling slack');
          fetch(
          "https://hooks.slack.com/workflows/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",
          {
            method: "post",
            body: JSON.stringify(slackObject)
          })
        }        
      });     
    },

    submitFutureDataToFirestore() {
      let data = this.inplayDataToDisplay.details;
      let slackObject = {
        futureBets: data.toString()
      } 

      let diff = slackObject.futureBets.replace(/,/g,"\n")
      let diff2 = diff.replace(/'|!|\[/g," ")
      slackObject.futureBets = diff2;

      fetch(
        "https://us-central1-dueawin-30cb4.cloudfunctions.net/futureBetUpdate",
        {
          method: "post",
          body: JSON.stringify(data)
        }
      ).then((response) => {
        console.log(response);
        if (response.status === 201) {
          console.log('calling slack');
          fetch(
          "https://hooks.slack.com/workflows/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",
          {
            method: "post",
            body: JSON.stringify(slackObject)
          })
        }        
      });
    },

    createResultsTable(specificYear) {
      let tableData;
      if (specificYear == "currentSheetData") {
        tableData = this.currentSheetData.values;
      } else {
        tableData = this.sheetData2018.values;
      }

      const tableObj = {};

      const dataToTableObject = tableData => {
        tableObj.yearheading = tableData[0];
        tableObj.tableheading = tableData[1];
        tableObj.names = tableData.slice(
          this.numberOfHeadings,
          this.numberOfHeadingsAndPeople
        );
        tableObj.details = tableData.slice(this.numberOfHeadingsAndPeople);

        if (specificYear == "currentSheetData") {
          this.currentYearDataToDisplay = tableObj;
        } else {
          this.year2018DataToDisplay = tableObj;
        }
      };

      dataToTableObject(tableData);
    },

    sortByWinAmountAndAddDollarSign(specificYear) {
      if (specificYear == "currentSheetData") {
        this.currentYearDataToDisplay.names.sort(compare);
        this.currentYearDataToDisplay.names.forEach(addDollarSign);
      } else {
        this.year2018DataToDisplay.names.sort(compare);
        this.year2018DataToDisplay.names.forEach(addDollarSign);
      }

      function compare(a, b) {
        if (parseFloat(a[1]) > parseFloat(b[1])) {
          return -1;
        }
        if (a[1 < b[1]]) {
          return 1;
        }
        return 0;
      }

      function addDollarSign(data) {
        data[1] = `£${data[1]}`;
      }
    },

    createInplayTable() {
      const tableObj = {};
      tableObj.tableheading = this.inplayData.values[0];
      tableObj.details = this.inplayData.values.slice(1);
      this.inplayDataToDisplay = tableObj;
    },

    // Init functions
    async initCurrentYear() {
      await this.fetchData(this.currentYearSelection, "currentSheetData");
      this.createResultsTable("currentSheetData");
      this.sortByWinAmountAndAddDollarSign("currentSheetData");
      this.submitDataToFirestore(this.currentYearDataToDisplay.names);      
    },
    async initInplay() {      
      await this.fetchData(this.inplaySelection, "inplay");
      this.createInplayTable();
      this.submitFutureDataToFirestore();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./src/assets/scss/global.scss";

/* Table styling */

.table-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

table {
  min-width: 320px;
  margin-bottom: 20px;
  color: white;
  border-spacing: 0;
  box-shadow: 5px 5px #88888831;
  th {
    padding: 10px 20px;
    background-color: $color-secondary;
    border-bottom: 1px solid #bf751f;
    text-align: left;
  }
  td {
    background-color: $color-primary;
    padding: 10px 20px;
    border-bottom: 1px solid rgba(179, 128, 144, 0.65);
    text-align: left;
  }
}

.inplay {
  tr:last-child {
    td {
      background-color: rgba($color-primary, 0.9);
    }
  }
}

h2.inplay {
  width: 100%;
}

.trophy {
  height: 20px;
}

// Media queries

@media (min-width: 640px) {
  table {
    min-width: 480px;
  }
}
</style>
